import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { icon, latLng, marker, polyline, tileLayer } from 'leaflet';
import { Map } from 'leaflet';
import { MapService } from '../services/map.service';
import { GlOnResize, GlOnShow, GlOnTab, GoldenLayoutContainer } from 'ngx-golden-layout';
import GoldenLayout, { Tab } from 'golden-layout';
import * as L from 'leaflet';
import { mapLayersControl, mapSatelliteLayer, mapStreetLayer } from 'shared';
import { first } from 'rxjs/operators';
import { MapLayersControlToolbar } from './map-layers-control/map-layers-control.component';
import { MapSidebarFilterService } from './map-sidebar-filter/map-sidebar-filter.service';
import { Subscription } from 'rxjs';

// @ts-ignore
window.L_DISABLE_3D = true;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, OnDestroy, AfterViewInit, GlOnShow, GlOnResize {

  public map: Map;
  @ViewChild('mapEl', { static: false })
  mapEl: ElementRef;

  //

  oldMapBox = tileLayer('https://api.mapbox.com/v4/{id}/{z}/{x}/{y}.png?style=mapbox://styles/mapbox/outdoors-v11@00&access_token=pk.eyJ1IjoicmJpc3RhIiwiYSI6ImNrM20ydTY2ZDBsNGszZXFvYmFwYWd3bzcifQ.xkuCV26UIIx_r-b44Wge1Q', {
    attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
      '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
      'Imagery © <a href="http://mapbox.com">Mapbox</a>',
    id: 'mapbox.satellite'
  });

  satelliteLayers = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    maxZoom: 22,
    maxNativeZoom: 18,
  });

  streetMaps = tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}', {
    // detectRetina: true,
    maxZoom: 22,
    maxNativeZoom: 18,
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  });

  layers = [
    {
      name: 'Satellite',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
    {
      name: 'Hybride',
      layer: tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&hl=ar-MA&gl=MA', {
        maxZoom: 21,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),
    },
  ];

  options = {
    layers: this.layers[0].layer, // this.layers.map(l => l.layer),
    zoom: 7,
    minZoom: 0,
    maxZoom: 21,
    maxNativeZoom: 21,
    preferCanvas: false,
    center: [33.626756199999996, -7.4964748],
  };
  mapCss: any;
  initialized = false;
  private sideFilterSub: Subscription;

  constructor(
    public mapService: MapService,
    private mapSidebarFilter: MapSidebarFilterService,
    @Inject(GoldenLayoutContainer) private container: GoldenLayout.Container,
  ) {
    this.mapCss = {
      width: this.container.getElement().width() + 'px',
      height: this.container.getElement().height() + 'px',
    };

    // @ts-ignore
    const originalInitTile = L.GridLayer.prototype._initTile;
    L.GridLayer.include({
      // @ts-ignore
      _initTile: function (tile) {
        originalInitTile.call(this, tile);

        // @ts-ignore
        const tileSize = this.getTileSize();

        tile.style.width = tileSize.x + 1 + 'px';
        tile.style.height = tileSize.y + 1 + 'px';
      }
    });
  }

  ngOnInit(): void {
  }

  onMapReady(map: Map) {
    this.map = map;
    this.mapService.map = map;
    L.control.scale({ imperial: false }).addTo(map);
  }

  ngAfterViewInit(): void {
  }

  glOnShow(): void {
    /*if (this.initialized) {
      return;
    }
    setTimeout(() => {
      this.mapCss = {
        width: this.container.width + 'px',
        height: this.container.height + 'px',
      };

      this.initialized = true;
    }, 80);*/
  }

  mapLayersControlLoaded(items: MapLayersControlToolbar) {
    items.add('fieldFilter', {
      location: 'before',
      locateInMenu: 'never',
      disabled: true,
      widget: 'dxButton',
      options: {
        elementAttr: { id: 'fieldMapFilter' },
        // stylingMode: this.mapSidebarFilter.filter.active() ? 'contained' : 'text',
        type: this.mapSidebarFilter.filter.active() ? 'default' : 'normal',
        icon: 'filter',
        text: 'Filter',
        onClick: () => {
          this.mapSidebarFilter.show();
        }
      }
    });

    this.mapService.mapReady$.pipe(first()).subscribe(() => {
      items.enable('fieldFilter');
    });

    // Sidebar filter
    this.sideFilterSub = this.mapSidebarFilter.filter$.subscribe(f => {
      items.options('fieldFilter', {
        // stylingMode: f.active() ? 'contained' : 'text',
        type: f.active() ? 'default' : 'normal',
      });
    });
  }

  glOnResize(): void {
    this.mapCss = {
      width: this.container.width + 'px',
      height: this.container.height + 'px',
    };
    this.mapService.mapReady$.pipe(first()).subscribe(() => {
      this.map.invalidateSize();
    });
  }

  ngOnDestroy(): void {
    this.sideFilterSub.unsubscribe();
  }

}
